import { GetCurrentUser200 } from '@platform/client/schemas';
import { ClientProgramNames } from '../constants';

// these should live in db but program team seems to change them frequently

/**Helper that takes db value of corporate_client.url_param and returns the correspondinb program string. */
export const getProgramNameFromParam = (clientName: string | undefined | null) => {
  let programName: string;
  switch (clientName?.toLowerCase()) {
    case 'sap':
      programName = ClientProgramNames.SAP;
      break;
    case 'f5':
      programName = ClientProgramNames.F5;
      break;
    case 'lumen':
      programName = ClientProgramNames.LUMEN;
      break;
    case 'ey':
      programName = ClientProgramNames.EY;
      break;
    case 'reckitt':
      programName = ClientProgramNames.RECKITT;
      break;
    default:
      programName = ClientProgramNames.INDIVIDUAL;
      break;
  }
  return programName;
};

/** Helper function to determine if user role is inactive for conditional platform access */
export const isInactiveUser = (user: GetCurrentUser200 | undefined): boolean => {
  if (!user) return false;
  return user.accountType === 'experteer' && user.role === 'inactive';
};

export const isCorporateProNoCohort = (user: GetCurrentUser200 | undefined): boolean => {
  if (!user) return false;
  return user.accountType === 'experteer' && !!user.corporatePartner && !user.cohort;
};
